import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// Redux Actions
import { setUserData, switchLoginStatus } from "../../redux/auth";
import { clearMessage, setMessage } from "../../redux/message";

// Components and Assets
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from "firebase/firestore";
import Layout from "../../components/Layout";
import {
  CButton,
  ContainerHeading,
  CookEInput,
} from "../../components/CommonComponents";
import { Dark_White_mode } from "../../utils/constants";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import {
  clearTokens,
  setAllDataForTokens,
} from "../../redux/tokens";
import { checkExpiration } from "../../utils/checkSubscriptionExpiration";


const initialState = {
  email: "",
  password: "",
};

function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const abc = useSelector((state) => state.tokens);
  const { message } = useSelector((state) => state.message);
  console.log(abc, "abc");

  const [values, setValues] = useState(initialState);
  const [visible, setIsVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    dispatch(clearMessage());
  }, []);

  const fetchData = async () => {
    const db = getFirestore();
    const userId = localStorage.getItem("uid");
    if (!userId) return;

    try {
      const usersQuery = query(
        collection(db, "Users"),
        where("userId", "==", userId)
      );
      const querySnapshot = await getDocs(usersQuery);

      if (!querySnapshot.empty) {
        // Directly access the first document
        const doc = querySnapshot.docs[0];
        const userData = doc.data();
        dispatch(setAllDataForTokens({...userData?.tokens,...userData?.subscriptionData}));

        const res = checkExpiration(userData?.currentPeriodEnd);
        console.log(userData, res);

        if (res) {
          setTimeout(() => {
            dispatch(clearTokens());
            // dispatch(setDownloadTokens(0));
            // dispatch(setSearchTokens(0));
            // dispatch(setUsedSearchTokens(-1));
            // dispatch(setUsedDownloadTokens(-1));
            // dispatch(setSubscriptionId(null));
            // dispatch(updateCurrentPeriodEndTimestamp(null));
            // window.location.reload();
          }, 5000);
        }
      } else {
        // Swal.fire({
        //   icon: "error",
        //   title: "Oops...",
        //   text: "Something went wrong!",
        // });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProfile = async (userId) => {
    const db = getFirestore();
    const usersCollection = collection(db, "Users");

    try {
      const q = query(usersCollection, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          const userData = doc.data();

          localStorage.setItem("photoURL", userData.photoURL);
        });
      } else {
        console.log("User not found");
      }
    } catch (error) {
      console.error("Error retrieving user:", error);
    }
  };

  const handleLogin = async () => {
    setIsVisible(true);
    try {
      const user = await signInWithEmailAndPassword(
        getAuth(),
        values.email,
        values.password
      );

      dispatch(switchLoginStatus(true));
      dispatch(setUserData(user));
      localStorage.setItem("uid", user.user.uid);
      localStorage.removeItem("photoURL");
      await fetchData(user.user.uid)
      getProfile(user.user.uid)
        .then(() => {
          navigate("/verify-email");
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      const errorMessage =
        {
          "auth/invalid-email": "Invalid email ID",
          "auth/user-not-found": "Please check your email",
          "auth/wrong-password": "Please check your password",
          "auth/too-many-requests": "Too many attempts, please try again later",
        }[err.code] || "An unexpected error occurred";

      dispatch(setMessage(errorMessage));
    }
    setIsVisible(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  return (
    <Layout variant="auth" setHeight={false}>

      <div className="">

        <ContainerHeading text={"Sign In"} />

        {/* Form */}
        <div>
          <form onSubmit={onSubmit} className="w-full px-4">
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <CookEInput
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="form-input w-full rounded-full text-gray-700"
                  placeholder="Enter your email "
                  required
                  label={"Email"}
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3 relative">
                <CookEInput
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  className="form-input w-full rounded-full text-gray-700"
                  placeholder="Password (at least 8 characters)"
                  required
                  label={"Password"}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute top-[36px] right-8 flex items-center text-sm sm:text-base md:text-lg font-babas text-gray-400  transition duration-150 ease-in-out"
                >
                  {showPassword ? <FaRegEyeSlash></FaRegEyeSlash> : <FaRegEye></FaRegEye>}
                </button>


              </div>
            </div>
            <div className="flex flex-wrap -mx-3 mb-4">
              <div className="w-full px-3">
                <div className="flex justify-between">
                  <Link
                    to="/reset-password"
                    className="text-orange-500 font-bold hover:underline transition duration-150 ease-in-out"
                  >
                    Forgot Password?
                  </Link>
                </div>
              </div>
            </div>
            <p className="mt-2 mx-3   text-md font-bold text-center text-gray-700">
              {message && (
                <div className="text-red-600 h-full " role="alert">
                  {message}
                </div>
              )}
            </p>
            <div className="flex flex-wrap -mx-3 mt-2">
              <div className="w-full px-3">
                {/* <Link to="/services"> */}
                <CButton
                  label={"Sign In"}
                  type="submit"
                  variant={"red"}
                  className={"w-full"}
                />
              </div>
            </div>
          </form>
          {visible && (
            <div className="z-50 absolute top-[50%] left-[50%] -translate-x-[50%]">
              <ColorRing
                visible={true}
                height="100"
                width="100"
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                colors={[
                  "#e15b64",
                  "#f47e60",
                  "#f8b26a",
                  "#abbd81",
                  "#849b87",
                ]}
              />
            </div>
          )}
          <div className={`${Dark_White_mode} text-center mt-6`}>
            Don’t you have an account?{" "}
            <Link
              to="/signup"
              className="text-pink-500 font-bold hover:underline transition duration-150 ease-in-out"
            >
              Sign up
            </Link>
          </div>
        </div>
      </div>

    </Layout>
  );
}

export default SignIn;
